import React, { Fragment, useMemo, useState } from "react";

import { getString, purifiedParsedString } from "../../utilities";
import strings from "../../strings";
import Arrow from "../../../assets/svg/arrowRight.svg";
import ArrowTip from "../../../assets/svg/arrowTip.svg";
import { userRoles } from "../../config/constants";

export default function Faq({ userRole, className = "" }) {
  const isFamily = userRole === userRoles.family || false;

  const [activeIndex, setActiveIndex] = useState(-1);
  const faqs = useMemo(
    () =>
      strings.subscribe.faq.data
        .filter((faq) => isFamily || !faq?.isOnlyForFamily)
        .map((faq, i) => {
          const question = Object.prototype.hasOwnProperty.call(faq, "family")
            ? getString(`subscribe.faq.data.${i}.question`, {
                replace: [getString(`subscribe.faq.data.${i}.${userRole?.toLowerCase()}`)],
              })
            : faq.question;
          const answer = purifiedParsedString(faq.answer);
          return { question, answer };
        }),
    [userRole],
  );

  const renderActiveAnswer = (isActive, answer) => {
    if (isActive && answer && answer.length > 0) {
      return (
        <div className="wrapper padded even">
          <div className="container-medium">{answer}</div>
        </div>
      );
    }

    return null;
  };

  const questionClickHandler = (index) => {
    const newIndex = index === activeIndex ? -1 : index;
    setActiveIndex(newIndex);
  };

  const renderFaqs = () => {
    return faqs.map((faq, index) => {
      const isActive = index === activeIndex;
      const titleStyle = isActive ? "active" : "";
      const arrow = isActive ? <Arrow className="toggle-title-arrow" /> : <ArrowTip className="toggle-title-arrow" />;

      return (
        <Fragment key={faq.question}>
          <button
            className={`wrapper toggle-title ${titleStyle}`}
            aria-expanded={isActive ? "true" : "false"}
            onClick={(e) => {
              e.preventDefault();
              questionClickHandler(index);
            }}
          >
            <div className="container toggle-title-container">
              <div className="toggle-title-text">{faq.question}</div>
              {arrow}
            </div>
          </button>
          {renderActiveAnswer(index === activeIndex, faq.answer)}
        </Fragment>
      );
    });
  };

  return (
    <div className={`subscribe-faq ${className}`}>
      <h2>{getString("subscribe.faq.title")}</h2>
      <div className="qna">{renderFaqs()}</div>
    </div>
  );
}
